import { useRef, useState, useEffect } from "react";
import classNames from "classnames";
import ReactTooltip from "react-tooltip";
import useClickOut from "../hooks/useClickOut";
import useBreakpoint from "../hooks/useBreakpoint";
import Icon from "./icon";

const Tooltip = ({ id, className, tooltipContent, reactTooltipProperties }) => {
  const isMobile = useBreakpoint(767);
  const [open, setOpen] = useState();
  const ref = useRef();
  useClickOut(open, setOpen, {
    get current() {
      return ref.current?.tooltipRef;
    },
  });

  useEffect(() => {
    if (!open) {
      ref.current.tooltipRef = null;
      ref.current.hideTooltip();
    }
  }, [open]);

  return (
    <div className={classNames("tooltip", className, open && "open")}>
      <div className="tooltip__text" data-tip data-for={id}>
        <div>
          <Icon name="info" />
        </div>
      </div>
      <ReactTooltip
        id={id}
        className="tooltip__popup"
        ref={ref}
        event={reactTooltipProperties?.event || "click"}
        effect={reactTooltipProperties?.effect || "solid"}
        place={
          (isMobile ? reactTooltipProperties?.mobilePlace : reactTooltipProperties?.place) ||
          "bottom"
        }
        arrowColor={reactTooltipProperties?.arrowColor || "white"}
        offset={isMobile ? reactTooltipProperties?.mobileOffset : reactTooltipProperties?.offset}
        afterShow={() => setOpen(true)}
        afterHide={() => setOpen(false)}
        scrollHide={false}
      >
        <div>{tooltipContent}</div>
      </ReactTooltip>
    </div>
  );
};

export default Tooltip;
